let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("etBZS")).then(() => parcelRequire('lQJdg'));